<template>
  <div
    class="client_info__container client_info__container--copay copay-clickable-container"
    :class="{ 'copay-is-not-enabled': !isCopayPaymentEnabled, 'copay-is-payd': copayIsPayd }"
  >
    <div style="display: flex; flex-direction: row; align-items: flex-start;">
      <template v-if="copay">
        <p class="payment__copay" @click="openPaymentOverlay">{{ $t('common.copay.title') }} {{ copayIsPayd ? $t('common.copay.is-paid') : '' }}: ${{ copay }}</p>
        <button class="tip_btn js--btn-tip" @click.stop="toggleTooltip">
          <i class="icon ">
            <svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M11 2.406c-4.74 0-8.594 3.856-8.594 8.594 0 4.74 3.856 8.594 8.594 8.594 4.74 0 8.594-3.856 8.594-8.594 0-4.74-3.856-8.594-8.594-8.594zm0 3.524a1.117 1.117 0 11.064 2.233A1.117 1.117 0 0111 5.93zm2.063 9.71H9.28a.688.688 0 010-1.375h1.204v-3.78h-.688a.688.688 0 110-1.375h1.375a.688.688 0 01.688.687v4.468h1.203a.687.687 0 110 1.375z" fill="#9f9d9c"/></svg>
          </i>
        </button>
        <p class="tip_help" :class="{ active: isTooltipActive }" @click.stop="toggleTooltip">
          {{ $t('common.copay.description') }}
        </p>
      </template>
      <template v-else>
        <p v-if="dateTimeAttempted" class="date-time-attempted">{{ dateTimeAttempted }}</p>
      </template>
      <payment-overlay
        v-if="isCopayPaymentEnabled"
        :is-open="isPaymentOverlayOpen"
        :amount="orderData.copay"
        :order-id="orderId"
        :order-data="orderData"
        @close="closePaymentOverlay"
      ></payment-overlay>
    </div>
    <p class="payment__id">#{{ orderId }}</p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PaymentOverlay from '@/components/_common/PaymentOverlay.vue'

export default {
  name: 'copay-block',
  components: {
    PaymentOverlay,
  },
  props: {
    dateTimeAttempted: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isTooltipActive: false,
      isPaymentOverlayOpen: false,
    }
  },
  computed: {
    ...mapGetters(['orderData']),
    copay() {
      return this.orderData.copay
    },
    orderId() {
      return this.orderData.uid
    },

    isCopayPaymentEnabled() {
      return this.orderData?.facility?.customize?.allow_copay_payments === 'yes'
        && this.orderData?.facility?.customize?.strip_public_key
        && !this.copayIsPayd
    },
    copayIsPayd() {
      return !!this.orderData?.paid_copay
    },
  },
  methods: {
    toggleTooltip() {
      this.isTooltipActive = !this.isTooltipActive
    },

    openPaymentOverlay() {
      // Проверяем включена ли оплата copay через Stripe
      if (!this.isCopayPaymentEnabled) {
        console.log('Copay payments are disabled')
        return
      }

      this.isPaymentOverlayOpen = true
    },
    closePaymentOverlay() {
      this.isPaymentOverlayOpen = false
    },
  },
}
</script>

<style lang="scss" scoped>
.copay-clickable-container {
  cursor: pointer;
}
.copay-is-not-enabled {
  cursor: default;
}
.copay-is-payd {
  .payment__copay {
    background-color: #9BE13F;
  }
}
</style>
